import gql from 'graphql-tag';

export const GET_LOGIN_FORM_DATA = gql`
  query GetLoginInfo($redirect_url: String) {
    loginFormData(redirect_url: $redirect_url) {
      session_id
      oauth_error
      user {
        email
        avatar_url
        sign_in_method
      }
      team {
        name
      }
    }
  }
`;

export const LOG_IN_ACCOUNT = gql`
  mutation loginAccount($loginRequest: LoginAccountRequest!) {
    loginAccount(LoginAccountRequest: $loginRequest) {
      status
      redirect_url
      required_next_step {
        type
        primary
        secondary
      }
      session_data
    }
  }
`;

export const GET_REGISTRATION_FORM_DATA = gql`
  query GetRegistrationInfo($onboarding_origin: String, $redirect_url: String) {
    registrationFormData(
      onboarding_origin: $onboarding_origin
      redirect_url: $redirect_url
    ) {
      session_id
      email
      team
      is_credit
      oauth_error
      oauth_app {
        name
        is_internal
      }
      marketplace_app {
        name
        icon
        create_app_url
      }
    }
  }
`;

export const CREATE_ACCOUNT = gql`
  mutation createAccount($createReq: CreateAccountRequest!) {
    createAccount(CreateAccountRequest: $createReq) {
      uuid
      redirect_url
    }
  }
`;

export const FORGOT_PASSWORD = gql`
  mutation forgotPassword($forgotPasswordRequest: ForgotPasswordRequest!) {
    forgotPassword(ForgotPasswordRequest: $forgotPasswordRequest) {
      status
    }
  }
`;

export const GET_PASSWORD_RESET_FORM_DATA = gql`
  query GetPasswordResetInfo($token: String) {
    resetPasswordFormData(token: $token) {
      status
    }
  }
`;

export const RESET_PASSWORD = gql`
  mutation resetPassword($resetPasswordRequest: ResetPasswordRequest!) {
    resetPassword(ResetPasswordRequest: $resetPasswordRequest) {
      status
    }
  }
`;

export const SEND_SMS = gql`
  mutation sendSms2fa($sendSms2faRequest: SendSms2faRequest!) {
    sendSms2fa(SendSms2faRequest: $sendSms2faRequest) {
      status
    }
  }
`;

export const TWO_FACTOR = gql`
  mutation twoFactorVerification($twoFactorRequest: TwoFactorRequest!) {
    twoFactorVerification(TwoFactorRequest: $twoFactorRequest) {
      status
      session_data
      redirect_url
    }
  }
`;

export const VERIFY_DEVICE = gql`
  mutation verifyDevice($verifyDeviceRequest: VerifyDeviceRequest!) {
    verifyDevice(VerifyDeviceRequest: $verifyDeviceRequest) {
      status
      redirect_url
      session_data
    }
  }
`;

export const REGISTER_REFERRAL_CODE = gql`
  query registerReferralCode($refcode: String) {
    registerReferralCode(refcode: $refcode) {
      status
    }
  }
`;
